import ServerError from '@/pages/error/ServerError'
import NotFoundError from '@/pages/error/NotFoundError'
import UnauthorizedError from '@/pages/error/UnauthorizedError'

const routes = [
  {
    path: '/server-error',
    name: 'ServerError',
    component: ServerError
  },
  {
    path: '/not-found-error',
    name: 'NotFoundError',
    component: NotFoundError
  },
  {
    path: '/unauthorized-error',
    name: 'UnauthorizedError',
    component: UnauthorizedError
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/router/errors.js